import React, { useEffect, useState } from "react";
import { SelectCustom } from "../../../Select";
import { useCreditSelector } from "../../../../stores/product/product.store";
import { CreditState } from "../../../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../../../stores/credit/credit.store";
import { setAddress, setCity, setShipping } from "../../../../stores/credit/credit.reducer";
import { PickupInterface } from "../../../../interfaces/credit/shipping-method.interface";
import { fetchTotalThunk } from "../../../../stores/credit/thunks/fetch-total.thunk";

interface LluProps {
    zones: PickupInterface[]
}

export const Llu: React.FC<LluProps> = ({ zones }) => {
    const translateText = useCreditSelector((state: CreditState) => state.text);
    const dispatch = useCreditDispatch();
    const [selectedZone, setSelectedZone] = useState<{ label: string; value: string } | null>(null);
    const [cityValue, setCityValue] = useState('');
    const [addressValue, setAddressValue] = useState('');

    const onChangeZones = (option: { label: string; value: string } | null) => {
        setSelectedZone(option);
        dispatch(setShipping(
            {
                zone: option!.value,
                cityId: '',
                pickup: '',
            }
        ));
        dispatch(fetchTotalThunk());
    };

    useEffect(() => {
          dispatch(setCity(cityValue));
    }, [cityValue]);

    useEffect(() => {
        dispatch(setAddress(addressValue));
    }, [addressValue]);


    return (
        <div>
            <div className="w-full mb-6">
                <label htmlFor="region"
                       className="text-sm font-medium mb-3 block text-black">{ translateText.region }<span
                    className="text-red-500"> *</span></label>
                <SelectCustom options={ zones.map(p => ({ label: p.name, value: p.code })) } onChange={ onChangeZones } value={ selectedZone } />
            </div>
            {
                selectedZone && <div>
                    <div className="w-full mb-6">
                        <label htmlFor="city"
                               className="text-sm font-medium mb-3 block text-black">{ translateText.city }<span
                            className="text-red-500"> *</span></label>
                        <input id="city"
                               type="text"
                               className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl"
                               value={ cityValue }
                               onChange={ (e) => setCityValue(e.target.value) }/>
                    </div>
                    <div className="w-full mb-6">
                        <label htmlFor="address"
                               className="text-sm font-medium mb-3 block text-black">{ translateText.address }<span
                            className="text-red-500"> *</span></label>
                        <input id="address"
                               type="text"
                               className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl"
                               value={ addressValue }
                               onChange={ (e) => setAddressValue(e.target.value) }/>
                    </div>
                </div>
            }
        </div>
    );
};
